import React, { useState, useEffect } from "react";
import "../styles/promo.css";

type PromoPopupProps = {
    message: string
    services?: Array<string>
}

const PromoPopup: React.FC<PromoPopupProps> = (props) => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const lastSeen = localStorage.getItem("promoLastSeen");

        const now = new Date().getTime();
        const timer = 5 * 60 * 1000; // 5 mins

        if (!lastSeen || now - parseInt(lastSeen, 10) > timer) {
            // Show popup after 1 second
            const timer = setTimeout(() => setShowPopup(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleClose = () => {
        setShowPopup(false);
        // Save the timestamp of when user last saw the popup
        localStorage.setItem("promoLastSeen", Date.now().toString());
    };

    if (!showPopup) return null;

    return (
        <div className="promo-overlay">
            <div className="promo-popup">
                <button className="promo-close" onClick={handleClose}>
                    &times;
                </button>
                <h2>Special Offer!</h2>
                <p>{props.message}</p>
                <div>{props.services?.map(s => <><span>{s}</span> <br /></>)}</div>
            </div>
        </div>
    );
};

export default PromoPopup;